<template>
  <div class="sales-analysis-drill-through-main">
    <div class="drill-through-body">
      <TableBox :title="tableTitle" :tableData.sync="drillThroughDetails" :dataType="{ 'Doc Date': 'date', 'Date': 'date', 'Amount': 'currency'}"/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drillThroughDetails: [],
      drillThroughType: '',
      tableTitle: '',
    };
  },
  props: {
  },
  methods: {
  },
  async mounted() {
    this.$fullscreenLoading('Getting Data');
    const details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName));
    this.drillThroughType = this.$route.params.drillThroughName.split('-')[1].trim().split(' ')[0].trim();
    let drillThroughData = [];
    let tableTitleTemp = '';

    if(this.drillThroughType.includes('DETAILS')){
      const postObject = details.data;
      const drillThrough = await this.$apiCallV2('/Sales/GetSalesAnalysis2', postObject);
      drillThroughData = drillThrough;

      if (!details.pnlonly) {
        tableTitleTemp = `Sales Analysis Details for ${details.series}`;
      } 
      else {
        tableTitleTemp = `Sales Analysis Details for ${details.series} - P & L Txn only`;
      }
    } 
    else if(details.salesperson.includes('Sales Analysis Summary')){ 
      this.drillThroughDetails = details.data;
      drillThroughData = details.data;
      if (!details.pnlonly) {
        tableTitleTemp = 'Sales Analysis Summary';
      } else {
        tableTitleTemp = `Sales Analysis Summary - P & L Txn Only`;
      }
    }
    else if(details.salesperson.includes('Collection Analysis Summary')){ 
      this.drillThroughDetails = details.data;
      drillThroughData = details.data;
      if (!details.pnlonly) {
        tableTitleTemp = 'Collection Analysis Summary';
      } else {
        tableTitleTemp = 'Collection Analysis Summary - P & L Txn only';
      }
    }
    this.$nextTick(() => {
      this.drillThroughDetails = drillThroughData;
      this.tableTitle = tableTitleTemp;
    });
    this.$fullscreenLoading('');
  },
  watch: {
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.sales-analysis-drill-through-main {
  font-size: 12px;
  padding: 5px 45px;

  > .drill-through-body {
    background-color: white;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    padding: 5px;
  }
}
</style>